<template>
	<div class="flex items-center justify-between">
		<NotificationTypeBase :notification="notification">
			<template #button>
				<AppButton @click="onClick"> Aanvraag bekijken </AppButton>
			</template>
		</NotificationTypeBase>
	</div>
</template>

<script setup lang="ts">
import { useZero } from "@/composables/useZero";
import { api } from "@/loanLinkApi";
import type { SpecificNotification } from "@/models/SpecificNotification";
import { queries } from "@loanlink-nl/zero";
import { useRouter } from "vue-router";

interface Props {
	notification: SpecificNotification<"loanApplication">;
}

const props = defineProps<Props>();
const router = useRouter();

async function onClick() {
	const applicationId = props.notification.metadata.loanApplicationId;

	// navigate to application details page
	const toApplicationPage = async (
		applicationId: string,
		dossierId: string,
	) => {
		const zero = useZero().value;
		const dossier = await zero.run(
			queries.dossier.byId({ field: "id", id: dossierId }),
		);
		if (dossier === undefined) {
			// eslint-disable-next-line no-console
			console.error("could not find dossier!"); // TODO: show error via toast
			return;
		}
		await router.push({
			name: "LoanApplicationDetailsPage",
			params: {
				loanApplicationId: applicationId,
				dossierDisplayId: dossier.displayId,
			},
		});
	};

	await api.loanApplication
		.getApplication(applicationId)
		.then((res) => toApplicationPage(res.data.id, res.data.dossierId))
		.catch((res) => {
			// eslint-disable-next-line no-console
			console.error(res.error); // TODO: show error via toast
		});
}
</script>
